import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';
import { computed } from 'vue';
// 
/**
 * fallback images when image returns error (screen backgrounds)
 * @returns fallback images data
 */
const alternativeImgPlugin = () => {
    const $q = useQuasar();
    const alternativeWebpSrcSet = computed(() => {
        if ($q.dark.isActive) {
            return `
        https://dminqct125wnz.cloudfront.net/common/default/listing/128_spaces_default2_dark.webp 128w,
        https://dminqct125wnz.cloudfront.net/common/default/listing/360_spaces_default2_dark.webp 360w,
        https://dminqct125wnz.cloudfront.net/common/default/listing/540_spaces_default2_dark.webp 540w,
        https://dminqct125wnz.cloudfront.net/common/default/listing/880_spaces_default2_dark.webp 880w,
        https://dminqct125wnz.cloudfront.net/common/default/listing/1280_spaces_default2_dark.webp 1280w,
        https://dminqct125wnz.cloudfront.net/common/default/listing/1500_spaces_default2_dark.webp 1500w,
        https://dminqct125wnz.cloudfront.net/common/default/listing/1920_spaces_default2_dark.webp 1920w
      `;
        }
        return `
      https://dminqct125wnz.cloudfront.net/common/default/listing/128_spaces_default2.webp 128w,
      https://dminqct125wnz.cloudfront.net/common/default/listing/360_spaces_default2.webp 360w,
      https://dminqct125wnz.cloudfront.net/common/default/listing/540_spaces_default2.webp 540w,
      https://dminqct125wnz.cloudfront.net/common/default/listing/880_spaces_default2.webp 880w,
      https://dminqct125wnz.cloudfront.net/common/default/listing/1280_spaces_default2.webp 1280w,
      https://dminqct125wnz.cloudfront.net/common/default/listing/1500_spaces_default2.webp 1500w,
      https://dminqct125wnz.cloudfront.net/common/default/listing/1920_spaces_default2.webp 1920w
    `;
    });
    const alternativeSrcSet = computed(() => {
        if ($q.dark.isActive) {
            return `
        https://dminqct125wnz.cloudfront.net/common/default/listing/128_spaces_default2_dark.jpeg 128w,
        https://dminqct125wnz.cloudfront.net/common/default/listing/360_spaces_default2_dark.jpeg 360w,
        https://dminqct125wnz.cloudfront.net/common/default/listing/540_spaces_default2_dark.jpeg 540w,
        https://dminqct125wnz.cloudfront.net/common/default/listing/880_spaces_default2_dark.jpeg 880w,
        https://dminqct125wnz.cloudfront.net/common/default/listing/1280_spaces_default2_dark.jpeg 1280w,
        https://dminqct125wnz.cloudfront.net/common/default/listing/1500_spaces_default2_dark.jpeg 1500w,
        https://dminqct125wnz.cloudfront.net/common/default/listing/1920_spaces_default2_dark.jpeg 1920w
      `;
        }
        return `
      https://dminqct125wnz.cloudfront.net/common/default/listing/128_spaces_default2.jpeg 128w,
      https://dminqct125wnz.cloudfront.net/common/default/listing/360_spaces_default2.jpeg 360w,
      https://dminqct125wnz.cloudfront.net/common/default/listing/540_spaces_default2.jpeg 540w,
      https://dminqct125wnz.cloudfront.net/common/default/listing/880_spaces_default2.jpeg 880w,
      https://dminqct125wnz.cloudfront.net/common/default/listing/1280_spaces_default2.jpeg 1280w,
      https://dminqct125wnz.cloudfront.net/common/default/listing/1500_spaces_default2.jpeg 1500w,
      https://dminqct125wnz.cloudfront.net/common/default/listing/1920_spaces_default2.jpeg 1920w
    `;
    });
    return { alternativeWebpSrcSet, alternativeSrcSet };
};
export { alternativeImgPlugin };
